import $ from 'jquery'
import ManageSectionFrom from '@/views/consultations/en-cours/consultation-sections/manage-section-form'
import PreviewFile from '@/views/consultations/en-cours/consultation-sections/preview-file'
import PlanSoinsExpress from '@/views/consultations/en-cours/consultation-sections/plan-soins-express'
import protocoleApi from '@/api/consultations/_protocole-soins'
import finance from '@/store/mods/finances/finance'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'consultation-sections',
    components: {
        ManageSectionFrom, PreviewFile, PlanSoinsExpress
    },
    props: {
        consultation: Object,
        enregistrer_rubrique: Function,
        section_name: String,
        slug: String,
        active_role: String,
        info_assurance_patient: {
            type: Object,
            default: () => ({})
        },
        fcs_id: {
            type: Number,
            default: () => (0)
        },
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        patient: Object
    },
    data() {
        return {
            is_loading: true,
            load_error: false,
            is_empty: false,
            info_patient: {},
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_contents: [],
            plans_soins: [],
            selected_content: [],
            data_to_be_deleted: {},

            liste_champs: [],
            liste_champ_empty: false,
            liste_champ_loading: true,
            champs_charges: false,
            form_open_loading: false,
            form_open_error: false,

            prev_info: {
                file_name: '',
                label: ''
            },
            prev_toggler: 0,
            c_slug: "",
            plan_express_toggler: 0,
            // Recette du 03/10 : modifier / supprimer un plan non réglé.
            plan_edition: null, plan_action_id: 0, plan_action_erreur: '', plan_caisse_a_retirer: null
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()

            this.userInfoSetter()
        }
    },

    computed: {
        kineValidatedCount() {
            return this.list_contents.filter(g => (g.fields || []).some(f => f.field_name === 'Présence validée — compter cette séance réalisée' && f.checked === true)).length
        },
        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },
    },


    mounted() {
        this.userInfoSetter()
        this.getData()
    },

    methods: {
        ouvrirPlanExpress() {
            this.plan_express_toggler = this.plan_express_toggler === 0 ? 1 : 0
        },
        planExpressEnregistre() {
            this.getData()
            this.$emit('plan-express-saved')
        },
        // Le serveur reste juge (auteur, caisse, installation, soins) ; l'écran n'affiche les
        // actions qu'au médecin auteur, sur l'évolution en cours, pour un plan non verrouillé.
        planModifiable(plan) {
            return this.active_role === 'ROLE_MEDECIN' && !plan.modification_bloquee
                && Number(plan.user_id) > 0 && Number(plan.user_id) === Number((this.user_info || {}).id)
                && this.current_consultation_evolution == this.evolution_id
        },
        modifierPlan(plan) {
            if (!this.planModifiable(plan) || this.plan_action_id) return
            this.plan_action_erreur = ''
            this.plan_edition = { protocole_id: Number(plan.protocole_id), jeton: Date.now() }
        },
        async supprimerPlan(plan) {
            if (!this.planModifiable(plan) || this.plan_action_id) return
            if (!window.confirm('Supprimer le plan ' + plan.reference + ' ? Ses lignes non réglées seront retirées de la caisse.')) return
            this.plan_action_id = Number(plan.protocole_id)
            this.plan_action_erreur = ''
            try {
                const reponse = await protocoleApi.supprimerPlanSoins(plan.protocole_id)
                if (!reponse || !reponse.success) throw new Error((reponse && reponse.message) || 'Suppression refusée.')
                this.getData()
                this.$emit('plan-express-saved')
                await this.retirerDeLaCaisse(Array.isArray(reponse.operations) ? reponse.operations : [])
                if (!this.plan_caisse_a_retirer) this.successToast('Plan de soins supprimé.')
            } catch (error) {
                this.plan_action_erreur = (error.response && error.response.data && error.response.data.message) || error.message || 'Impossible de supprimer ce plan.'
            } finally { this.plan_action_id = 0 }
        },
        async retirerDeLaCaisse(operations) {
            if (!operations.length) { this.plan_caisse_a_retirer = null; return }
            try {
                await finance.removeAllItemsFromCaisse({ operations })
                this.plan_caisse_a_retirer = null
                this.plan_action_erreur = ''
            } catch (error) {
                this.plan_caisse_a_retirer = operations
                this.plan_action_erreur = 'Plan supprimé, mais ses lignes n’ont pas pu être retirées de la caisse. Réessayez avant tout encaissement.'
            }
        },
        getListeChamps() {
            this.liste_champ_loading = true
            const data = {
                fcs_id: this.fcs_id
            }
            return store_fiche.geListeChampByFicheSection(data).then((response) => {
                this.liste_champs = Array.isArray(response) ? response.filter(field => this.slug.indexOf('kine_') !== 0 || Number(field.is_active) === 1) : []
                this.champs_charges = true

                if (this.liste_champs.length == 0) {
                    this.liste_champ_empty = true
                } else {
                    this.liste_champ_empty = false
                }
                this.liste_champ_loading = false
            }).catch((error) => {
                this.liste_champ_loading = false
                throw error
            })
        },

        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'M':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age,
                date_naissance: this.formatDateToDmY(this.patient.date_naissance)
            }

            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        async addNew() {
            if (!this.enregistrer_rubrique && this.slug === 'cca_plan_de_traitement' && this.active_role === 'ROLE_MEDECIN') {
                this.ouvrirPlanExpress()
                return
            }
            if (this.form_open_loading) return
            this.form_open_error = false
            if (!this.champs_charges) {
                this.form_open_loading = true
                try {
                    await this.getListeChamps()
                } catch (error) {
                    this.form_open_error = true
                    return
                } finally {
                    this.form_open_loading = false
                }
            }
            this.group_id = 0
            this.selected_content = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#section-'+this.evolution_id+'-'+this.slug).modal('show')
        },

        async editGrs(group) {
            if ((!this.enregistrer_rubrique && this.slug !== 'synthese_consultation' && this.slug.indexOf('kine_') !== 0) || this.form_open_loading ||
                group.user_id !== this.user_info.id || this.current_consultation_evolution !== this.evolution_id) return
            this.form_open_error = false
            if (!this.champs_charges) {
                this.form_open_loading = true
                try {
                    await this.getListeChamps()
                } catch (error) {
                    this.form_open_error = true
                    return
                } finally {
                    this.form_open_loading = false
                }
            }
            this.group_id = Number(group.group_service_id)
            this.selected_content = Array.isArray(group.fields) ? group.fields : []
            this.grs_toggler = this.grs_toggler === 0 ? 1 : 0
            $('#section-'+this.evolution_id+'-'+this.slug).modal('show')
        },

        getData() {
            if (this.enregistrer_rubrique && this.evolution_id < 0) {
                this.is_loading = false
                this.is_empty = true
                return
            }
            this.is_loading = true
            this.load_error = false
            if (this.slug === 'cca_plan_de_traitement') {
                protocoleApi.getConsultationProtocoleSoins({ consultation_id: this.consultation.id, evolution_id: this.evolution_id })
                    .then(response => { this.plans_soins = Array.isArray(response) ? response : [] })
                    .catch(() => { this.plans_soins = [] })
            }
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: this.slug,
                est_en_cours: true
            }

            store_fiche.getCustomSectionContent(data).then((response) => {
                this.list_contents = Array.isArray(response) ? response : []
                if (this.list_contents.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
            }).catch(() => {
                this.list_contents = []
                this.is_empty = true
                this.load_error = true
            }).finally(() => {
                this.is_loading = false
            })
        },

        previewFile(data) {
            this.prev_toggler = (this.prev_toggler == 0)?1:0

            this.prev_info = {
                file_name: data.value,
                label: data.field_name
            }

            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp
            setTimeout(() => {
                $('.preview-file-'+this.evolution_id+this.c_slug).modal('show')
            }, 500);
            
        },

        removeSection(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: this.slug
            }

            $('.del-grp-sect'+this.evolution_id+this.slug).modal('show')
        }
    }
}
